import {Component} from 'react';
import '../../css/styles.css';
import DocumentLinkCard from './document_link_card';

class LessonList extends Component {
        constructor(props) {
            super(props);
            this.state={
                
        }
            
    }
        
    render() {
         this.linkColumn1= this.props.outInfo.linkArr1.map((linkItem,key) =>
            <DocumentLinkCard key={key} outInfo={linkItem}  />
                );  
        this.linkColumn2= this.props.outInfo.linkArr2.map((linkItem,key) =>
            <DocumentLinkCard key={key} outInfo={linkItem}  />
                );  
    return <>
            <div className="col-sm-6 mt-4">
                <b>{this.props.outInfo.lesson1Name} - {this.props.outInfo.lesson1Title}</b>
                    
                <div className="ml-4">
                    {this.linkColumn1}
                </div>
            </div>
            <div className="col-sm-6 mt-4">
                <b>{this.props.outInfo.lesson2Name} - {this.props.outInfo.lesson2Title}</b>
                <div className="ml-4">
                    {this.linkColumn2}
                </div>
            </div>
        </>
    }



}

export default LessonList;